import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
export const CardListRow = ({ hoverable, children, sx: sxProps, ...rest }) => (_jsx(Box, { sx: [
        (theme) => ({
            p: 4,
            pl: 6,
            width: '100%',
            transition: theme.transitions.create(['background-color'], {
                duration: theme.transitions.duration.shortest,
                easing: theme.transitions.easing.easeInOut,
            }),
            ...(hoverable && {
                '&:hover': {
                    // @ts-expect-error - palette is not typed correctly
                    backgroundColor: theme.palette.neutral[200],
                    cursor: 'pointer',
                },
            }),
        }),
        ...(Array.isArray(sxProps) ? sxProps : [sxProps]),
    ], ...rest, children: children }));
